import "./sentry.js";
import "./bootstrap";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import collapse from "@alpinejs/collapse";
import { registerAirwallexCheckout } from "./airwallex-checkout.js";
import { registerStripeCheckout } from "./stripe-checkout.js";
import { registerBraintreeCheckout } from "./braintree-checkout.js";

window.tippy = tippy;

document.addEventListener("alpine:init", () => {
    Alpine.plugin(collapse);

    registerAirwallexCheckout();
    registerStripeCheckout();
    registerBraintreeCheckout();
});

document.addEventListener("livewire:initialized", () => {
    Livewire.hook("element.init", (el, component) =>
        setTimeout(() => tippy("[data-tippy-content]"), 700),
    );
});
